export type TextPart = { text: string; isMatch: boolean };

/**
 * Splits a string around every case-insensitive occurrence of a query. Compared
 * as plain text: order numbers carry characters a regular expression would read
 * as syntax.
 */
export function splitMatches(
  text: string | undefined,
  query: string,
): TextPart[] {
  if (!text) {
    return [];
  }

  const needle = query.trim().toLowerCase();

  if (!needle) {
    return [{ text, isMatch: false }];
  }

  const parts: TextPart[] = [];
  const haystack = text.toLowerCase();
  let cursor = 0;

  while (cursor < text.length) {
    const found = haystack.indexOf(needle, cursor);

    if (found === -1) {
      parts.push({ text: text.slice(cursor), isMatch: false });
      break;
    }

    if (found > cursor) {
      parts.push({ text: text.slice(cursor, found), isMatch: false });
    }

    parts.push({
      text: text.slice(found, found + needle.length),
      isMatch: true,
    });
    cursor = found + needle.length;
  }

  return parts;
}
